import {post, get, del} from '@/utils/request'

// 获取套餐列表
export function getMPosListAPI(data) {
    return post({
        data,
        url: 'resource/mpos/list'
    })
}
// 删除套餐
export function deleteMPosAPI(id) {
    return del({
        url: `resource/mpos/${id}`
    })
}

// 套餐导入
export function importMposDataAPI(data) {
    return post({
        data,
        url: 'resource/mpos/batch'
    })
}

//=========

// 获取套餐列表
export function getPackageLitListAPI(data) {
    return post({
        data,
        url: 'tbs/TbsPackageProjectRelation/list'
    })
}

// 删除套餐
export function deletePackageAPI(id) {
    return del({
        url: `tbs/TbsPackageProjectRelation/removeById/${id}`
    })
}

// 套餐导入
export function importPackageDataAPI(data) {
    return post({
        data,
        url: 'tbs/TbsPackageProjectRelation/upload'
    })
}
// 删除套餐管理1211
// export function delRestrict(id) {
//     return del({
//         url: `tbs/TbsPackageProjectRelation/remove/${id}`
//     })
// }
export function delRestrict(data) {
    console.log('+++data+++',data);
    return post({
        data,
        url: `tbs/TbsPackageProjectRelation/remove`
    })
}